// Fixed list, mirrors TexasAlarms.Api's ProductService.AllowedUnitLabels
// exactly (Batch82_ProductUnitLabel.sql) - the server validates against
// this same set, so keep both in sync if it ever changes. Shared by the
// Product Master form and every Stock document's line-item Unit column
// (LineItemsEditor.jsx) so "Unit" means the same fixed, real thing
// everywhere in the project instead of free text typed differently on
// every screen.
export const UNIT_LABELS = [
  "NOS", "PCS", "ROLL", "LTR", "KG", "MTR", "BOX", "PAIR", "SET", "BAG", "CTN", "DZN", "PKT", "BTL", "TIN",
];
